import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const SITE_URL = "https://clirago.com";

const PAGE_META = {
  "/": {
    title: "Christian Lira González | Analytics Engineer",
    description:
      "Christian Lira Gonzalez — Analytics Engineer. Building data platforms from pipeline to delivery. ELT pipelines, Microsoft Fabric, Power BI, Python, SQL.",
  },
  "/about": {
    title: "About — Christian Lira González",
    description:
      "Background, education, and experience of Christian Lira Gonzalez: BYU-Idaho, Tesla, and the path to becoming an Analytics Engineer.",
  },
  "/projects": {
    title: "Projects — Christian Lira González",
    description:
      "Analytics engineering and data engineering projects by Christian Lira Gonzalez: ELT pipelines, SQL analytics, Power BI, and machine learning.",
  },
  "/resume": {
    title: "Resume — Christian Lira González",
    description:
      "View or request the resume of Christian Lira Gonzalez, Analytics Engineer specializing in ELT pipelines and BI delivery.",
  },
  "/contact": {
    title: "Contact — Christian Lira González",
    description:
      "Get in touch with Christian Lira Gonzalez for hiring, collaboration, or consulting inquiries.",
  },
};

export default function usePageMeta() {
  const { pathname } = useLocation();

  useEffect(() => {
    const meta = PAGE_META[pathname] || PAGE_META["/"];

    document.title = meta.title;

    const descTag = document.querySelector('meta[name="description"]');
    if (descTag) descTag.setAttribute("content", meta.description);

    const canonicalTag = document.querySelector('link[rel="canonical"]');
    if (canonicalTag) canonicalTag.setAttribute("href", `${SITE_URL}${pathname}`);
  }, [pathname]);
}
